<template>
  <template v-if="authStore.canBid">
    <template v-if="lot.closed">
      <span
        v-if="myLot.winner && !isRedistribute"
        class="inline-block bg-green-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.you_won') }}
      </span>
      <span
        v-else-if="myLot.winner && isRedistribute"
        class="inline-block bg-orange-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.preempted') }}
      </span>
      <span
        v-else
        class="inline-block bg-stone-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.closed') }}
      </span>
    </template>
    <template v-else>
      <span
        v-if="myLot.winner && !isRedistribute"
        class="inline-block bg-green-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.you_are_winning') }}
      </span>
      <span
        v-else-if="myLot.winner && isRedistribute"
        class="inline-block bg-orange-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.preempted') }}
      </span>
      <span
        v-else-if="isOutbid"
        class="inline-block bg-yellow-500 p-1 mx-4 text-white uppercase text-xs font-bold"
      >
        {{ $t('lot.outbid') }}
      </span>
    </template>
  </template>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth';

const props = defineProps({
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: false,
        default: null
    },
    isOutbid: {
        type: Boolean,
        required: false
    },
    isRedistribute: {
      type: Boolean,
      required: false,
      default: false
    }
})

const authStore = useAuthStore();
</script>